module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.slide.image.sizes.slide,
      "width": "700",
      "height": "400"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.slide.content)
    }
  }), _vm._v(" "), (_vm.slide.button_link !== 'none') ? _c('p', [(_vm.slide.button_link === 'ext') ? _c('a', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "href": _vm.slide.button_link_external,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.slide.button_link_text))]) : _vm._e(), _vm._v(" "), (_vm.slide.button_link === 'int') ? _c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": _vm.internalLink
    }
  }, [_vm._v(_vm._s(_vm.slide.button_link_text))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.index === 0) ? _c('div', [_vm._m(0)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": "https://www.paypal.com/donate",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "YHVZYZS95QJY2"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "submit",
      "value": "Father’s Day Backpack Drive",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f290643!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Slide.vue
// module id = 380
// module chunks = 2